import React from 'react'


const Registrations = () => {

    

    return (
        <div className="shop-details-page-area">
            <div className="container">
                <h3 className='text '>Government Registration and Approvals</h3>
                <div className="row">
                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                        <div className="inner-shop-details">
                            <div className="product-details-info-area">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div className="inner-product-details-left">
                                            <div className='featured-box'>
                                                <div className='featured-img-holder hvr-bounce-to-right'>
                                                    <img src='/images/Reg_img/Registration1.png' alt='images'></img>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3 col-md-8">
                                        <div className="inner-product-details-right">
                                            <h3>Ministry Of Corporate Affairs Government Of India</h3>
                                            <ul className='learning-outcomes'>
                                                <li> CIN No. - U74999DL2016NPL299102 </li> <br />
                                                <li> Registration No. 299102</li>
                                            </ul>



                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                        <div className="inner-shop-details">
                            <div className="product-details-info-area">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div className="inner-product-details-left">
                                            <div className='featured-box'>
                                                <div className='featured-img-holder hvr-bounce-to-right'>
                                                    <img src='/images/Reg_img/Registration2.png' alt='images'></img>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3 col-md-8">
                                        <div className="inner-product-details-right">
                                            <h3>Ministry Of Micro Small And Medium Enterprises Government Of India</h3>
                                            <ul className='learning-outcomes'>
                                                <li> Registration No. UDYAM-DL-03-0018679</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                        <div className="inner-shop-details">
                            <div className="product-details-info-area">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div className="inner-product-details-left">
                                            <div className='featured-box'>
                                                <div className='featured-img-holder hvr-bounce-to-right'>
                                                    <img src='/images/Reg_img/Registration3.jpg' alt='images'></img>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3 col-md-8">
                                        <div className="inner-product-details-right">
                                            <h3>NITI Aayog Government Of India</h3>
                                            <ul className='learning-outcomes'>
                                                <li> NGO-DARPAN</li> <br/>
                                                <li> Registration No. DL/2022/0309240</li>
                                            </ul>
                                           


                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                        <div className="inner-shop-details">
                            <div className="product-details-info-area">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div className="inner-product-details-left">
                                            <div className='featured-box'>
                                                <div className='featured-img-holder hvr-bounce-to-right'>
                                                    <img src='/images/Reg_img/Registration4.png' alt='images'></img>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3 col-md-8">
                                        <div className="inner-product-details-right">
                                            <h3>Quality Management System ISO Certified</h3>
                                            <ul className='learning-outcomes'>
                                                <li>Quality Research Organization </li> <br />
                                                <li> Certificate No. 305024010927Q</li>
                                            </ul>



                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>



                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                        <div className="inner-shop-details">
                            <div className="product-details-info-area">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div className="inner-product-details-left">
                                            <div className='featured-box'>
                                                <div className='featured-img-holder hvr-bounce-to-right'>
                                                    <img src='/images/Reg_img/Registration5.png' alt='images'></img>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3 col-md-8">
                                        <div className="inner-product-details-right">
                                            <h3>Accredited By Egyptian Accreditation Council, Egypt</h3>
                                            <ul className='learning-outcomes'>
                                                <li> International Accreditation Forum </li> <br />
                                                <li> Quality Research Organization</li><br />
                                                <li> Accredated No. #119005</li>
                                            </ul>



                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                        <div className="inner-shop-details">
                            <div className="product-details-info-area">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div className="inner-product-details-left">
                                            <div className='featured-box'>
                                                <div className='featured-img-holder hvr-bounce-to-right'>
                                                    <img src='/images/Reg_img/Registration6.jpg' alt='images'></img>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3 col-md-8">
                                        <div className="inner-product-details-right">
                                            <h3>Registered : NCS, Ministry Of Labour And Employment, Govt. Of India</h3>
                                            <ul className='learning-outcomes'>
                                                <li> National Career Service, Ministry of Labour & Employment, Govt. of India. NCS </li> <br />
                                                <li> Registration No. S13J68-1136066524360</li>
                                            </ul>



                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                        <div className="inner-shop-details">
                            <div className="product-details-info-area">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div className="inner-product-details-left">
                                            <div className='featured-box'>
                                                <div className='featured-img-holder hvr-bounce-to-right'>
                                                    <img src='/images/Reg_img/Registration7.png' alt='images'></img>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3 col-md-8">
                                        <div className="inner-product-details-right">
                                            <h3>12A And 80G Registered Under Income Tax Department Government Of India</h3>
                                            <ul className='learning-outcomes'>
                                                <li> 80G Registration No. AAECI1180JF20221 </li> <br />
                                                <li> 12A Registration No. AAECI1180JE20211</li>
                                            </ul>



                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>                    


                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                        <div className="inner-shop-details">
                            <div className="product-details-info-area">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div className="inner-product-details-left">
                                            <div className='featured-box'>
                                                <div className='featured-img-holder hvr-bounce-to-right'>
                                                    <img src='/images/Reg_img/Registration1.png' alt='images'></img>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3 col-md-8">
                                        <div className="inner-product-details-right">
                                            <h3>CSR Registration Under Ministry Of Corporate Affairs Government Of India</h3>
                                            <ul className='learning-outcomes'>
                                                <li> Registration No. CSR00028529</li> 
                                            </ul>



                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                        <div className="inner-shop-details">
                            <div className="product-details-info-area">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div className="inner-product-details-left">
                                            <div className='featured-box'>
                                                <div className='featured-img-holder hvr-bounce-to-right'>
                                                    <img src='/images/Reg_img/Registration8.png' alt='images'></img>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3 col-md-8">
                                        <div className="inner-product-details-right">
                                            <h3>Department Of Labour Government Of National Capital Territory Of Delhi</h3>
                                            <ul className='learning-outcomes'>
                                                <li> Registration No. 2022136462</li> 
                                            </ul>



                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>


                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3">
                        <div className="inner-shop-details">
                            <div className="product-details-info-area">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                        <div className="inner-product-details-left">
                                            <div className='featured-box'>
                                                <div className='featured-img-holder hvr-bounce-to-right'>
                                                    <img src='/images/Reg_img/Registration9.png' alt='images'></img>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-18 col-md-18 col-sm-18 col-xs-18 col-md-push-3 col-md-8">
                                        <div className="inner-product-details-right">
                                            <h3>Asian International University, Manipur, UGC Approved</h3>
                                            <ul className='learning-outcomes'>
                                                <li> Registration No. AIU54304 </li> 
                                            </ul>



                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>




    )
}

export default Registrations